<template>
    <div class="date-picker app">
        <y-header @go-back="handleGoBack" title="选择时间"></y-header>
        <div class="date-picker__top font48 color-4F">
            <span :class="type === 'date' ? 'color-orange' : ''" @click="switchPicker('date')">按日选择</span>
            <span :class="type === 'year-month' ? 'color-orange' : ''" @click="switchPicker('year-month')">按月选择</span>
        </div>
        <div class="body-padding">
            <div class="date-picker__content" v-if="type === 'date'">
                <span style="flex: 1" class="font40 color-primary" @click="handleDate" data-type="0">{{date.length !== 0 ? date[0] : '开始时间'}}</span>
                <span style="width: 0.5rem" class="font40 color-4F">至</span>
                <span style="flex: 1" class="font40 color-primary" @click="handleDate" data-type="1">{{date.length === 2 ? date[1] :'结束时间' }}</span>
            </div>
            <div class="date-picker__content" v-else>
                <span style="flex: 1" class="font40 color-primary" @click="handleDate" data-type="0">{{month.length === 0 ? '月份' : month}}</span>
            </div>
            <div v-show="visible">
                <van-datetime-picker
                        ref="datepicker"
                        :show-toolbar="false"
                        v-model="currentDate"
                        :type="type"
                        :formatter="formatter"
                />
                <div class="date-picker__bottom">
                    <van-button class="confirm-btn" type="warning" round @click="confirm">确认</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            YHeader: () => import('@/components/common/header/Header')
        },
        props: {
            hideDate: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                type: 'date',
                visible: false,
                currentDate: new Date(),
                date: [],
                month: ''
            };
        },
        methods: {
            handleGoBack() {
                this.$emit('update:hideDate', true)
            },
            formatter(type, value) {
                if (type === 'year') {
                    return `${value}年`;
                } else if (type === 'month') {
                    return `${value}月`
                } else if (type === 'day') {
                    return `${value}日`
                }
                return value;
            },
            switchPicker(val) {
                this.type = val
            },
            handleDate(e) {
                this.visible = this.visible ? false : e.target.dataset.type
            },
            confirm() {
                if (this.type === 'date') { // 按日
                    this.date[this.visible] = $moment(this.currentDate).format('YYYY-MM-DD')
                    this.$emit('select-date', this.date)
                    if (this.date.length === 2) this.$emit('close')
                } else { // 按月
                    this.month = $moment(this.currentDate).format('YYYY-MM')
                    this.$emit('select-date', this.month)
                    this.$emit('close')
                }
                this.visible = false
            }
        }
    }
</script>

<style scoped lang="less">
    .date-picker {
        z-index: 999;
        text-align: center;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        .date-picker__top {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;
            padding: 0.41rem 1.43rem;
        }

        .date-picker__content {
            height: 1.25rem;
            background-color: #fff;
            margin-bottom: 0.03rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0.48rem 1.28rem;
        }


        .date-picker__bottom {
            margin-top: 0.03rem;
            background-color: #fff;
            height: 1.92rem;
            line-height: 1.92rem;

            .confirm-btn {
                width: 8.84rem;
                height: 0.96rem;
                line-height: 0.96rem;
                background-color: unset;
                color: #FE9329;
            }
        }
    }
</style>
